var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3033 9.75736L8.53034 14.5303C8.23745 14.8232 7.76257 14.8232 7.46968 14.5303L2.69671 9.75736C2.40381 9.46447 2.40381 8.98959 2.69671 8.6967C2.9896 8.40381 3.46447 8.40381 3.75737 8.6967L7.25001 12.1893L7.25001 2C7.25001 1.58579 7.58579 1.25 8.00001 1.25C8.41422 1.25 8.75001 1.58579 8.75001 2L8.75001 12.1893L12.2426 8.6967C12.5355 8.40381 13.0104 8.40381 13.3033 8.6967C13.5962 8.98959 13.5962 9.46447 13.3033 9.75736Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/SortAscending.92d32f785f09f726c629079940bb31d6.svg";
export { ForwardRef as ReactComponent };